import request from '@/utils/request'
import qs from 'qs'
export function getCancelTransactionList(query) {
  return request({
    url: '/report-service/v1/cancel-transaction-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getCancelTransactionListExcel(query) {
  return request({
    url: '/report-service/v1/cancel-transaction-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
